import { Link } from "react-router-dom";
import FacebookIcon from "../../assets/web/icons/FacebookIcon";
import InstagramIcon from "../../assets/web/icons/InstagramIcon";
import LinkedInIcon from "../../assets/web/icons/LinkedInIcon";
import YoutubeIcon from "../../assets/web/icons/YoutubeIcon";
import LogoFooter from "../../assets/web/images/logo-footer.svg";
import Container from "./Container";

export default function Footer() {
  return (
    <footer className="bg-[#001652] text-[#FFFFFFBF] py-20">
      <Container>
        <div className="flex justify-center">
          <img src={LogoFooter} alt="" className="w-28" />
        </div>
        <div className="text-center my-10">
          <div>Dial: +880-18333-09-555 | E-mail: sbusiness@sheba.xyz</div>
          <div className="text-[12px]">
            H#454, R#31, Mohakhali DOHS, Dhaka-1206, Bangladesh.
          </div>
        </div>
        <nav className="text-white flex gap-6 font-semibold justify-center my-10">
          <Link to="">Apps</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="">Stories</Link>
          <Link to="">Contact</Link>
        </nav>

        <div className="flex justify-center gap-5 items-center">
          <a href="">
            <FacebookIcon />
          </a>
          <a href="">
            <YoutubeIcon />
          </a>
          <a href="">
            <LinkedInIcon />
          </a>
          <a href="">
            <InstagramIcon />
          </a>
        </div>
      </Container>
    </footer>
  );
}
